<template>
    <nav v-show="moreThanOnePage" class="flex items-center justify-evenly px-4 py-3 bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700/75 border-transparent space-x-2 sm:px-6" aria-label="Pagination">
        <div class="flex flex-1 -mt-px w-0 text-gray-600 text-sm">{{ total | toLocaleString }} {{ label | pluralize(this.total) }}</div>
        <div class="hidden xl:flex xl:-mt-px xl:space-x-2">
            <div v-for="(link, i) in links" :key="i">
                <Link
                    v-if="link.url"
                    :href="link.url"
                    :only="[only]"
                    preserve-scroll
                    preserve-state
                    :class="[link.active ? 'bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-slate-900' : 'text-gray-700 dark:text-slate-600 hover:text-gray-900 hover:bg-gray-50 dark:hover:bg-slate-700 dark:hover:text-slate-900']"
                    class="inline-flex items-center px-5 py-3 text-xs font-medium rounded-lg"
                    aria-current="page"
                >
                    {{ link.label }}
                </Link>
                <div v-else class="inline-flex items-center px-5 py-3 text-gray-500 text-xs font-medium cursor-default">{{ link.label }}</div>
            </div>
        </div>
        <div class="text-gray-500 text-sm font-medium xl:hidden">{{ currentPage }} / {{ lastPage }}</div>

        <div class="flex flex-1 justify-end -mt-px space-x-3">
            <Link
                :href="previousPageUrl"
                :only="[only]"
                preserve-scroll
                preserve-state
                :class="{ 'pointer-events-none opacity-50': previousPageUrl === '' }"
                class="inline-flex items-center px-3 py-2 text-gray-700 text-sm font-medium leading-4 hover:bg-gray-50 bg-white border border-gray-300 rounded-md focus:outline-none shadow-sm focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
                Previous
            </Link>
            <Link
                :href="nextPageUrl"
                :only="[only]"
                preserve-scroll
                preserve-state
                :class="{ 'pointer-events-none opacity-50': nextPageUrl === '' }"
                class="inline-flex items-center px-3 py-2 text-gray-700 text-sm font-medium leading-4 hover:bg-gray-50 bg-white border border-gray-300 rounded-md focus:outline-none shadow-sm focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
                Next
            </Link>
        </div>
    </nav>
</template>

<script>
export default {
    name: "Pagination",

    props: {
        data: {
            default: () => {},
            type: Object,
        },
        only: {
            default: "paginate",
        },
        label: {
            type: String,
            default: "result",
        },
    },

    computed: {
        moreThanOnePage() {
            return this.data.meta.to > 2
        },

        links() {
            return _.drop(_.dropRight(this.data.meta.links))
        },

        previousPageUrl() {
            return this.data.links.prev ?? ""
        },

        nextPageUrl() {
            return this.data.links.next ?? ""
        },

        currentPage() {
            return this.data.meta.current_page
        },

        lastPage() {
            return this.data.meta.last_page
        },

        total() {
            return this.data.meta.total
        },
    },
}
</script>
